<template>
<v-card v-if="menu" :flat="$vuetify.breakpoint.xsOnly">
    <v-divider></v-divider>
    <template v-if="showPizza">
        <v-subheader class="title">
            Módulos
        </v-subheader>
        <v-card flat :to="{name:'Pizza'}" hover>
            <v-layout>
                <v-flex>
                    <v-card-text class="py-1">
                        <v-layout row align-center justify-center>
                            <v-flex xs1 ml-2>

                            </v-flex>
                            <v-flex xs2 mr-2>
                                <v-avatar size="32">
                                    <v-img src="https://api.socialplace.com.br/static/CategoriaProduto/57f296120681a85b827ee121.jpg">
                                    </v-img>
                                </v-avatar>
                            </v-flex>
                            <v-flex xs9 md7>
                                <span class="subheading">Pizzaria (BETA)</span>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-flex>
            </v-layout>
        </v-card>
        <v-divider divider></v-divider>
    </template>
    <v-list>
        <v-subheader class="title">Categorias</v-subheader>
        <v-card flat @click="showForm()" hover>
            <v-card-text class="py-1">
                <v-layout row align-center>
                    <v-flex xs2 mr-2>
                        <v-avatar>
                            <v-icon>add</v-icon>
                        </v-avatar>
                    </v-flex>
                    <v-flex>
                            <span class="subheading">Adicionar uma categoria</span>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-card>
        <v-card flat :to="{name:'AllProducts'}" hover>
            <v-layout>
                <v-flex>
                    <v-card-text class="py-1">
                        <v-layout row align-center justify-center>
                            <v-flex xs1 ml-2 class="hidden-md-and-up">

                            </v-flex>
                            <v-flex xs2 ml-1>
                                <v-avatar size="32">
                                    <v-icon>visibility</v-icon>
                                </v-avatar>
                            </v-flex>
                            <v-flex xs9 md7>
                                <span class="subheading">Todos os produtos</span>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-flex>
            </v-layout>
        </v-card>
        <sp-type :tipo="tipoPending"></sp-type>
        <sp-type :tipo="tipoHighlight"></sp-type>
        <draggable :value="menuWithoutDefault" group="types" @change="onChange" :handle="$vuetify.breakpoint.smAndDown?'.handle':''" class="draggable">
            <sp-type :key="tipo.order" v-for="tipo in menuWithoutDefault" :tipo="tipo" style="transform:translateZ(0px);"></sp-type>
        </draggable>
        <sp-type :tipo="tipoCombo"></sp-type>
    </v-list>
    <v-dialog v-model="typeDialog" max-width="860px"
        persistent scrollable :fullscreen="$vuetify.breakpoint.xsOnly"
    >
        <sp-form-type @close="typeDialog=false">
        </sp-form-type>
    </v-dialog>
</v-card>
</template>

<script>
import {mapGetters} from 'vuex'
import orderBy from 'lodash/orderBy'
import draggable from 'vuedraggable'
import SpFormType from "./SpFormType";
import SpType from './SpType'

export default {
    components:{
        draggable,
        SpType,
        SpFormType
    },
    data(){
        return {
            drag:false,
        }
    },
    computed:{
        ...mapGetters([
            'restaurant'
        ]),
        tipoPending(){
            return this.menu.find(v=>v.name.toLowerCase()=='pendentes')
        },
        tipoHighlight(){
            return this.menu.find(v=>v.highlight)
        },
        tipoCombo(){
            return this.menu.find(v=>v.name.toLowerCase()=='produtos combo')
        },
        menuWithoutDefault(){
            return this.menu.filter(v=>
                !v.highlight &&
                ['pendentes','produtos combo'].indexOf(v.name.toLowerCase()) == -1)
        },
        menu:{
            get(){
                return this.$store.getters.menu
            },
            set(menu){
                return this.$store.commit('FETCH_MENU',menu)
            }
        },
        typeDialog:{
            get(){
                return this.$store.state.typeDialog
            },
            set(v){
                this.$store.state.typeDialog = v
            }
        },
        showPizza(){
            const pizzarias = [
                '5b537ae7ebf25e63c28934de',
                "5dfa12afebf25e45783901ce",
                "5dfa12a2ebf25e50f4446a2c"
            ]
            return pizzarias.indexOf(this.restaurant.tag_default) != -1
        },
    },
    methods:{
        showForm(type=null){
            this.$store.commit('FETCH_TYPE',type)
            this.$store.commit('TOGGLE_TYPE_DIALOG')
        },
        onChange(evt){
            if(evt.moved){
                let data = Object.assign({},evt.moved.element)
                delete data.image
                data.order = evt.moved.newIndex
                if(evt.moved.oldIndex > evt.moved.newIndex){
                    data.order += 0.5
                }else{
                    data.order += 1.5
                }
                this.$store.dispatch('createType',data)
            }
        },
        async setType(){
            this.$store.state.loading = true
            this.$store.commit('SET_TYPE',null)
            await this.$store.dispatch('fetchProducts')
            this.$store.state.loading = false
        },
    }
}
</script>

<style lang="scss">
    .router-link-exact-active{
        .v-card__text{
            .layout{
                .flex{
                    color:var(--v-secondary-base)
                }
            }
        }
    }
</style>

